import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function LegalCoverSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-end h-full">
      <SlideWaveBackground />
      <div className="relative z-10 max-w-4xl mt-auto">
        <h1 className="text-[48px] font-light tracking-tight mb-6 font-[family-name:var(--font-heading)]">
          AI Paralegal Agents<br />for Modern Law Firms
        </h1>
        <p className="text-[18px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
          AI agents that help legal teams organise evidence, prepare applications, and deliver submission-ready case files. Across every practice area, with compliance built in.
        </p>
      </div>
    </div>
  );
}
